<!-- Make sure Mat modules (MatExpansionModule, MatIconModule, MatInputModule, MatButtonModule) are imported in your module.
     Also add Material Icons in index.html:
     <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet"> -->

<div class="hero-and-controls">
  <div class="image-container">
    <img src="assets/navimage.png" class="hero-img" alt="School Guidelines" />
    <div class="image-text">
      <p>School Guidelines</p>
    </div>
  </div>
</div>

<div class="accordion-wrapper" id="accordionWrapper">
  <mat-accordion multi="false">

    <!-- NOTE: we attach #panelHost to read the host element, #panelContent to read panel body. Keep data-title attribute for search. -->

    <mat-expansion-panel #panelHost data-title="A Few Words for Students" class="panel-host" [expanded]="true">
      <mat-expansion-panel-header class="panel-header">
        <mat-panel-title>
          <mat-icon class="header-icon">menu_book</mat-icon>
          A Few Words for Students
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="panel-content" #panelContent>
        <p>
          Dear Students,<br /><br />
          I am pleased to give this school diary to you. I am sure that you will make
          proper use of it. Please read the following points carefully:
        </p>

        <ul class="content-list">
          <li>You will bring your diary daily to school without fail.</li>
          <li>You will note your homework and other school activities in the diary every day.</li>
          <li>Your diary must be shown to the parents/guardian and brought back with their replies.</li>
          <li>Keep your diary neat and clean.</li>
          <li>Bio-data must be filled correctly by the parents.</li>
        </ul>

        <p>
          Please plan your home-study schedule in consultation with your parents. Whenever you begin studying
          at home, first read the homework instructions given by your teacher and complete them before anything else.
        </p>

        <p class="signature">— Principal</p>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel #panelHost data-title="Regulations" class="panel-host">
      <mat-expansion-panel-header class="panel-header">
        <mat-panel-title>
          <mat-icon class="header-icon">gavel</mat-icon>
          Regulations
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="panel-content" #panelContent>
        <ul class="content-list">
          <li>On all school working days, wearing the school uniform is compulsory.</li>
          <li>Defaulters will be fined Rs. 10/- each day and may be suspended.</li>
          <li>After three defaults, the student will be sent back home at the cost and responsibility of the parents.</li>
        </ul>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel #panelHost data-title="Responsibilities of the School" class="panel-host">
      <mat-expansion-panel-header class="panel-header">
        <mat-panel-title>
          <mat-icon class="header-icon">shield</mat-icon>
          Responsibilities of the School
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="panel-content" #panelContent>
        <p>
          The school does not hold responsibility for the loss of books, stationery, or valuables
          during school hours or while commuting. Parents must ensure their ward does not carry objectionable items.
        </p>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel #panelHost data-title="Morning Prayer" class="panel-host">
      <mat-expansion-panel-header class="panel-header">
        <mat-panel-title>
          <mat-icon class="header-icon">auto_awesome</mat-icon>
          Morning Prayer
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="panel-content" #panelContent>
        <p>
          O God, our loving Father, origin of all knowledge, we pray to You to enlighten our minds,
          help us study well, obey elders, protect our country, seek truth always, and make us good children of Yours.
        </p>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel #panelHost data-title="Prayer Before Meals" class="panel-host">
      <mat-expansion-panel-header class="panel-header">
        <mat-panel-title>
          <mat-icon class="header-icon">restaurant</mat-icon>
          Prayer Before Meals
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="panel-content" #panelContent>
        <p>
          Bless us, O Lord, and these Your gifts which we are about to receive from Your bounty.
        </p>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel #panelHost data-title="School Discipline" class="panel-host">
      <mat-expansion-panel-header class="panel-header">
        <mat-panel-title>
          <mat-icon class="header-icon">rule</mat-icon>
          School Discipline
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="panel-content" #panelContent>
        <p>
          Discipline is the backbone of development in all spheres of life. Students must maintain self-discipline.
        </p>

        <ul class="content-list">
          <li>Arrive 10 minutes before school time.</li>
          <li>The warning bell signals assembly movement.</li>
          <li>Remain friendly with everyone.</li>
          <li>Avoid vulgar talk or behaviour.</li>
          <li>Physical assault may lead to expulsion.</li>
          <li>Care for classrooms and school property.</li>
          <li>Report damages; fines may apply.</li>
          <li>Crackers, colours, transistors, etc., are prohibited.</li>
        </ul>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel #panelHost data-title="House System" class="panel-host">
      <mat-expansion-panel-header class="panel-header">
        <mat-panel-title>
          <mat-icon class="header-icon">groups</mat-icon>
          House System
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="panel-content" #panelContent>
        <p>
          To promote leadership, confidence, and team spirit, students are divided into houses named after great leaders.
        </p>

        <h4 class="sub-heading">Duties Include:</h4>

        <ul class="content-list">
          <li>Morning assembly management.</li>
          <li>Maintaining cleanliness.</li>
          <li>Checking latecomers.</li>
          <li>Marking uniforms.</li>
          <li>Maintaining discipline during recess.</li>
          <li>Inter-house competitions.</li>
        </ul>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel #panelHost data-title="Instructions to Students" class="panel-host">
      <mat-expansion-panel-header class="panel-header">
        <mat-panel-title>
          <mat-icon class="header-icon">assignment</mat-icon>
          Instructions to Students
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="panel-content" #panelContent>

        <h4 class="sub-heading">A. Every Student Must:</h4>
        <ul class="content-list">
          <li>Bring diary daily.</li>
          <li>Come neat, clean, and in complete uniform.</li>
          <li>Maintain 80% attendance.</li>
          <li>Attend morning assembly regularly.</li>
          <li>Be fair, honest, and helpful.</li>
          <li>Respect elders and teachers.</li>
          <li>Look after school property.</li>
          <li>Keep classrooms clean.</li>
        </ul>

        <h4 class="sub-heading">B. Every Student Must Not:</h4>
        <ul class="content-list">
          <li>No leave without Principal’s approval.</li>
          <li>Submit leave application same/next day after absence.</li>
          <li>Medical certificate for leave beyond 5 days.</li>
          <li>Absence for 10 days may result in removal from rolls.</li>
        </ul>
      </div>
    </mat-expansion-panel>

  </mat-accordion>
</div>

